import { Flex, OverflowText, Text, TooltipWrapper } from "@theorgchartdev/storybook";
import { MoreFieldsListPopover } from "@/appComponents/Blocks/Cards/SourceInfoCard/MoreFieldsListPopover";

export const ModifiedRecordFields = ({ recordDetails }) => {
  if (!recordDetails?.source) {
    return;
  }

  const modifiedFields = recordDetails.modified ?? [];
  const sourceInfo = recordDetails.source;
  const sourceDetails = sourceInfo?.details;

  if (modifiedFields.length === 0) return;

  const fieldLabelProps = {
    size: "xsmall",
    colorModifier: "grey",
    modifier: "bold"
  };

  const valueLabelProps = {
    size: "xsmall"
  };

  return (
    <Flex direction={"column"} gap={"2px"}>
      <Flex direction={"column"} gap={"2px"}>
        <Text {...fieldLabelProps}>{"Modified by "}</Text>
        <Text {...valueLabelProps}>{parseInt(modifiedFields.length) + " source(s):"}</Text>
      </Flex>
      {modifiedFields.map((modObj, index) => {
        const changedFields = modObj["keys"];
        const displayFields = changedFields.slice(0, 3).join(", ");
        const updateSource = modObj["updateSource"];
        let tableName = "";
        let modToolTip = undefined;
        let modName = modObj["name"];

        if (updateSource && updateSource["name"]) tableName = updateSource["name"];
        else if (sourceDetails && typeof sourceDetails === "object" && sourceDetails["datafile"])
          tableName = sourceDetails["datafile"];

        if (modObj["type"] === "merge") {
          tableName = modObj["name"] ? modObj["name"] : "";
          modName = "Merge";
          modToolTip = modObj["details"] && modObj["details"].length > 0 ? modObj["details"] : "";
        }

        const numShown = 2;
        const showMoreFieldsPopover = changedFields.length > numShown;

        return (
          <Flex gap={"2px"} direction={"column"} padding={"0 0 0 12px"}>
            <OverflowText size={"xsmall"}>{`\u2022 ${tableName} (${modName})`}</OverflowText>
            <Flex padding={"0 0 0 12px"}>
              <Text size={"xsmall"} colorModifier={"lightgrey"}>
                {displayFields}
              </Text>
              {showMoreFieldsPopover && (
                <MoreFieldsListPopover
                  fields={changedFields}
                  numberShown={numShown}
                  size={"xsmall"}
                />
              )}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
